import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AuthServiceService } from './auth-service.service';
import { LocalServiceService } from './local-service.service';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  public userToken: any = null;
  constructor(
    public auth: AuthServiceService,
    private local: LocalServiceService,
    private sharedService: SharedService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.toString().includes('/chat/')) {
      this.auth.enableLoader = true;
    }


    if (request.url === environment.whtsappCloudUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${environment.whtsappCloudToken}`
        },
      });
      return next.handle(request);
    }

    if (this.sharedService.isBrowser() && !this.userToken && localStorage.getItem('user')) {
      try {
        this.userToken = JSON.parse(localStorage.getItem('user')).token
      } catch (e) { this.userToken = null; }
    }

    if (this.userToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.userToken}`
        },
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.auth.enableLoader = false;
        }
      }),
      catchError((e: any) => {
        this.auth.enableLoader = false;
        if ((e.error.status == 401 || e.status == 401)) {
          this.local.logout();
          if (typeof window !== 'undefined') {
            window.location.reload();
          }
        }
        throw (e);
        return of(e);
      })
    );
  }


}